const getLoopPropsLimit = (values, limit) => {
  let valuesLimit = 1;
  if (!values) return valuesLimit;
  Object.keys(values).forEach(key => {
    const value = values[key];
    if (value && Array.isArray(value) && value.length > valuesLimit) valuesLimit = value.length;
  });
  if (!limit || valuesLimit < limit) return valuesLimit;
  return limit;
};
export default getLoopPropsLimit;
//# sourceMappingURL=get-loop-props-limit.js.map